import { render, staticRenderFns } from "./NavInvestment.vue?vue&type=template&id=08bea538&"
import script from "./NavInvestment.vue?vue&type=script&lang=js&"
export * from "./NavInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports